import {
  faFacebook,
  faInstagramSquare,
  faLinkedin,
  faTelegram,
  faTwitter,
} from '@fortawesome/free-brands-svg-icons';

const freeBrandsSvgIcons = {
  facebook: faFacebook,
  instagramSquare: faInstagramSquare,
  linkedin: faLinkedin,
  telegram: faTelegram,
  twitter: faTwitter,
} as const;

export { freeBrandsSvgIcons };
